import { lazy } from 'react';
import { pageUrl } from '../services/pageUrl';

export const documents_routes = [
  // #########################################################################################
  // #############                Document               ###########################
  // #########################################################################################
  {
    exact: true,
    path: pageUrl.document.signature_document.liste,
    component: lazy(() => import('../views/menu/documents/signature_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.authority_document.liste,
    component: lazy(() => import('../views/menu/documents/authority_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.generation_document.liste,
    component: lazy(() => import('../views/menu/documents/generation_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.validation_document.liste,
    component: lazy(() => import('../views/menu/documents/validation_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.sign_list.liste,
    component: lazy(() => import('../views/menu/documents/sign_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.gestion_doc_list.liste,
    component: lazy(() => import('../views/menu/documents/gestion_document/index')),
  },
  {
    exact: true,
    path: pageUrl.document.history_list.liste,
    component: lazy(() => import('../views/menu/documents/history_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.generation_doc_list.liste,
    component: lazy(() => import('../views/menu/documents/generation_doc_pouvoir/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.validation_doc_list.liste,
    component: lazy(() => import('../views/menu/documents/validation_document/table/index')),
  },
  {
    exact: true,
    path: pageUrl.document.DocSociete_generation.liste,
    component: lazy(() => import('../views/menu/documents/document_societe/generation/index')),
  },
  {
    exact: true,
    path: pageUrl.document.DocSociete_validation.liste,
    component: lazy(() => import('../views/menu/documents/document_societe/validation/index')),
  },
  {
    exact: true,
    path: pageUrl.document.mandant.liste,
    component: lazy(() => import('../views/menu/documents/mandant/table/index')),
  },
];
